module.exports = __webpack_public_path__ + "img/side_auv.6a8fea2e.png";